<template>
  <div class="col-3 mb-3">
    <label>{{ fieldName }}</label>
    <dropdownlist
      class="w-100"
      :data-items="dataSource"
      :default-value="fieldName"
      :value="value"
      @change="$emit('input', $event.target.value)"
    ></dropdownlist>
  </div>
</template>
<script>
export default {
  name: "DropdownList",
  props: ["multi", "dataSource", "name", "fieldName", "value"],
};
</script>
